import { customTheme } from 'theme';

import { barStyles, commonStyles } from '../styles';
import { customizedLegend } from '../utils';

export const defaultStyles = {
  barChart: {
    margin: {
      top: 30,
      right: 30,
    },
  },
  tooltip: {
    contentStyle: {
      fontSize: '14px', //backgroundColor: customTheme.colors.gray['700'], color: 'white'
      borderRadius: customTheme.radii.cardBorderRadius,
    },
  },
  legend: {
    wrapperStyle: {
      top: 0,
    },
    align: 'right',
    iconSize: 8,
    formatter: customizedLegend,
  },
  bar: barStyles,
  ...commonStyles,
};
